import { CampaignResponse } from '../campaign/campaign-response';
import { dateFromString } from '@/shared/utils/date-time';
import { CampaignCheckStatuses } from '../campaign/campaign-check-statuses';

export class TestCaseResponse {
    id: number
    name: string
    created: Date
    listId: string
    subjects: string[]
    bodies: string[]
    deliveryServers: number[]
    trackingDomains: number[]
    useDeliveryServerTrackingDomain: boolean
    campaigns: CampaignResponse[]
    mailWizzInstanceId: number

    get totalCampaigns() { return this.campaigns.length }
    get queuedCampaigns() { return this.campaigns.filter(x => x.status == CampaignCheckStatuses.Queued ).length }
    get sentCampaigns() { return this.campaigns.filter(x => x.status == CampaignCheckStatuses.Sent ).length }
    get checkedCampaigns() { return this.campaigns.filter(x => x.status == CampaignCheckStatuses.Checked ).length }
    get erroredCampaigns() { return this.campaigns.filter(x => x.status == CampaignCheckStatuses.Errored ).length }

    static parseJson(json: any): TestCaseResponse {
        if (json === null || json === undefined) { 
            return null;
        }

        const { created, campaigns, ...rest } = json

        const testCase = Object.assign(new TestCaseResponse(), rest)
         
        testCase.created = dateFromString(created)
        testCase.campaigns = (campaigns || []).map(x => CampaignResponse.parseJson(x))

        return testCase
    }
}